import { ssoApi } from "@sso/apis";
import { ActivationEmailKeys, ApiMethodKeys, notificationsMsgs, SnackbarKeys } from "@sso/constant";
import { setActivationEmailStatus } from "@sso/store/slices/auth";
import { pushSnackbar } from "@sso/store/slices/snackbar";
import { QueryParameters, SignInType, SignUpType } from "@sso/types";

import { Endpoints } from "../endpoints";

export const registrationApi = ssoApi.injectEndpoints({
  endpoints: builder => ({
    signUp: builder.mutation<void, Partial<SignUpType>>({
      query: data => ({ url: `${Endpoints.REGISTRATION}/Register`, method: ApiMethodKeys.POST, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.SIGNUP }));
        });
      },
    }),
    resendActivationEmail: builder.mutation<void, SignInType>({
      query: data => ({ url: `${Endpoints.REGISTRATION}/SendEmailConfirmation`, method: ApiMethodKeys.POST, data }),
      onQueryStarted(_, { dispatch, queryFulfilled }) {
        queryFulfilled.then(() => {
          dispatch(setActivationEmailStatus(ActivationEmailKeys.SENT_EMAIL));
          dispatch(pushSnackbar({ type: SnackbarKeys.SUCCESS, title: notificationsMsgs.RESND_ACTIVATION_EMAIL }));
        });
      },
    }),
    emailConfirmation: builder.mutation<void, QueryParameters>({
      query: params => ({ url: `${Endpoints.REGISTRATION}/ConfirmEmail`, params }),
    }),
  }),
});

export const { useSignUpMutation, useEmailConfirmationMutation, useResendActivationEmailMutation } = registrationApi;
